import { Component, OnInit, inject, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms'; // Importa FormsModule
import { CommonModule, formatDate } from '@angular/common';
import { NgbDatepickerModule, NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from "../../modal/modal.component";
import { InicioService } from '../../../services/inicio.service';
import { EjecucionService } from '../../../services/ejecucion.service';
import { I18n, CustomDatepickerI18n } from '../../../clases/idioma-fecha';
import { appsettings } from '../../../settings/appsettings';

@Component({
  selector: 'app-listar-asistencia',
  standalone: true,
  imports: [CommonModule, ModalComponent, FormsModule, NgbDatepickerModule],
  templateUrl: './listar-asistencia.component.html',
  styleUrl: './listar-asistencia.component.css',
  providers: [
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }
  ],
})
export class ListarAsistenciaComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  @Input() id_accion_formativa?: any;
  @Input() anio?: any;
  @Input() nombre_oferta?: any;
  @Input() uc_pre_impreso?: any;
  @Input() fecha_inicio?: any;
  @Input() fecha_fin?: any;
  @Output() vuelve = new EventEmitter<any>();

  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;

  user: any;

  resultado: any = [];
  filteredResultado: any[] = []; // Nuevo array para los resultados filtrados
  errorMessage: string = '';
  searchTerm: string = ''; // Variable para almacenar el término de búsqueda
  fechaActual: string = '';

  // 1. Declarar las propiedades para los límites de fecha
  minDate!: NgbDateStruct;
  maxDate!: NgbDateStruct;
  fechaSeleccionada!: NgbDateStruct;

  private srvLogin = inject(InicioService);
  private servicios = inject(EjecucionService);


  ngOnInit(): void {
    this.srvLogin.user$.subscribe(user => { this.user = user; });
    const fecha = new Date();
    this.fechaActual = formatDate(fecha, 'dd-MM-yyyy', 'en-US'); // Formato: día/mes/año
    // Fecha de inicio: 22-09-2025
    this.minDate = this.convierteDtpick(this.fecha_inicio);
    // Fecha de fin: 20-10-2025
    this.maxDate = this.convierteDtpick(this.fecha_fin);
    // 2. 💡 Establecer el valor por defecto: ¡Aquí está la automatización!
    // Se inicializa el modelo del input con la fecha mínima.
    this.fechaSeleccionada = this.minDate;
  }


  ngAfterViewInit(): void {
    const fechaISO = this.convertirStructAISO(this.fechaSeleccionada);
    this.mdl.cargando();
    this.servicios.listaAsistencia(this.id_accion_formativa.toString(), fechaISO).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        //this.resultado = rs.data;
        // 🚨 CAMBIO CLAVE AQUÍ: Inicializar la propiedad de asistencia
        //this.validador = this.resultado.length == 0 ? false : true;

        this.resultado = rs.data.map((item: any) => ({
          ...item,
          // Asumimos que inicialmente todos están presentes (true),
          // o puedes usar el valor que venga del backend si existe.
          //asistencia: item.asistencia || true
          asistencia: item.asistencia
        }));

        if(this.resultado.length == 0){
          this.vuelve.emit({value: false, validador: false, warning: 2});
        }
        else{
          this.filteredResultado = [...this.resultado]; // Inicializa los resultados filtrados con todos los datos
          console.log(rs.data);
        }


      },
      error: (error) => {
        this.errorMessage = error.message;
      },
    });

  }



  // Método para filtrar la tabla
  buscarAccionFormativa() {
    this.filteredResultado = this.resultado.filter((item: any) => {
      const nombreOferta = item.nombre_oferta ? this.quitarAcentos(item.nombre_oferta.toLowerCase()) : '';
      const ucPreImpreso = item.uc_pre_impreso ? item.uc_pre_impreso.toLowerCase() : '';
      const nombreFacilitador = item.nombre_facilitador ? this.quitarAcentos(item.nombre_facilitador.toLowerCase()) : '';
      const term = this.searchTerm.toLowerCase();
      return (
        nombreOferta.includes(term) ||
        ucPreImpreso.includes(term) ||
        nombreFacilitador.includes(term)
      );
    });
  }

  quitarAcentos(str: string): string {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  // Esta función es vital para convertir tus strings a NgbDateStruct
  convierteDtpick(date: string):NgbDateStruct {
    // Asumiendo que tu string de entrada es 'DD-MM-YYYY'
    let array = date.split("-");
    return {
      year: parseInt(array[2]),
      month: parseInt(array[1]), // El NgbDateStruct usa meses 1-12
      day: parseInt(array[0])
    };
  }

  convertidor(numero: number): string {
    return numero < 10 ? `0${numero}` : numero.toString();
  }

  convertirStructAISO(date: NgbDateStruct): string {
    if (!date) {
      return '';
    }
    // Aseguramos el padding '0' para meses y días (ej: 9 -> 09)
    const year = date.year;
    const month = String(date.month).padStart(2, '0');
    const day = String(date.day).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  asistencias(){
    const fechaISO = this.convertirStructAISO(this.fechaSeleccionada);
    this.mdl.cargando();
    this.servicios.listaAsistencia(this.id_accion_formativa.toString(), fechaISO).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        //this.resultado = rs.data;
        // 🚨 CAMBIO CLAVE AQUÍ: Inicializar la propiedad de asistencia
        this.resultado = rs.data.map((item: any) => ({
          ...item,
          //asistencia: item.asistencia || true
          asistencia: item.asistencia
        }));
        this.filteredResultado = [...this.resultado]; // Inicializa los resultados filtrados con todos los datos
        console.log(rs.data);
      },
      error: (error) => {
        this.errorMessage = error.message;
      },
    });
  }

  confirmacion(){
      this.mdl.confirma();
  }

  guardar_todo(){
    // Este array contiene todos los objetos de estudiante (filtrados o no)
    // y la propiedad 'asistencia' (true/false) ya está actualizada por ngModel
    const datosParaGuardar = this.filteredResultado.map(estudiante => ({
        id_participante: estudiante.id_participante,
        asistencia: estudiante.asistencia, // El valor true/false del checkbox
        // ... puedes incluir más campos si los necesitas para la lógica de guardado
    }));
    const fechaISO = this.convertirStructAISO(this.fechaSeleccionada);
    let datos = {
      "id_accion_formativa": parseInt(this.id_accion_formativa),
      "fecha": fechaISO,
      "participantes": datosParaGuardar
    }

    console.log("Datos listos para ser enviados al servicio:", datos);
    this.mdl.cargando();
    this.servicios.cargarAsistencia(datos).subscribe({
      next: (rs) => {
        console.log('prueba:  ',rs)
        this.mdl.cerrar();
        this.vuelve.emit({value: false, validador: true, warning: 0});
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });

    // Aquí llamarías a tu servicio para guardar en la base de datos
    // this.servicios.guardarAsistencias(datosParaGuardar).subscribe({ ... });

    // Ejemplo de lo que verás en la consola:
    /*
    [
      { identificacion: '123456', asistencia: true },
      { identificacion: '789012', asistencia: false },
      // ...
    ]
    */


  }

  volver(){
    this.vuelve.emit({value: false, validador: false, warning: 0});
  }



}
